import cn from 'classnames';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import Button from 'components/basic/Button';
import { H1, H3 } from 'components/basic/Typography';
import TwicePaymentInstructionsLink from 'components/pagesComponents/payments/PaymentSuccessPage/TwicePaymentInstructionsLink';

import { useAppSelector } from 'redux-store';

import s from './PaymentProcessingSuccess.module.scss';

export default function PaymentProcessingSuccess({
  redirectUrl,
}: {
  redirectUrl?: string;
}): JSX.Element {
  const t = useTranslationAndTypograph();
  const router = useRouter();
  const profileStore = useAppSelector(state => state.profile);
  const purchaseStore = useAppSelector(state => state.purchases);
  const productsStore = useAppSelector(state => state.products);
  const { productPage } = productsStore;
  const isGiftPage = productPage === 'gift';
  const { userAgent } = useAppSelector(state => state.ui);
  const isMobile = userAgent.device.type === 'mobile';
  const compact = router.query.compact as string | undefined;
  const giftCoupon = router.query.gift_coupon as string | undefined;

  useEffect(() => {
    document.body.style.background = 'radial-gradient(221.13% 85.95% at 55.47% 0%, #2C3A5E 9.14%, #031529 46.54%)';
    return () => {
      document.body.style.background = '';
    };
  }, []);

  let button = {
    href: redirectUrl || 'https://welltory.com',
  };
  const returnToApp = isMobile && compact;

  if (returnToApp) {
    button = {
      href: 'welltory://action/web_payment?status=success',
    };
  }

  let footerContent = (
    <div className={s.linkToMainPages}>
      <Button
        className={s.linkToMainPage}
        look="rainbow"
        size="large"
        {...button}
      >
        {returnToApp ? t('Start enjoying') : t('Back to main page')}
      </Button>
    </div>
  );

  if (profileStore.isAuthenticated && purchaseStore.isFetched) {

    const mobileSubscriptionIndex = purchaseStore.purchases.findIndex(
      purchase => {
        return (
          purchase.payment_plan.payment_system === 1 ||
          purchase.payment_plan.payment_system === 2
        );
      },
    );

    if (mobileSubscriptionIndex !== -1) {
      const subscription = purchaseStore.purchases[mobileSubscriptionIndex];

      footerContent = (
        <TwicePaymentInstructionsLink
          className={s.doubleSubscriptionWrapper}
          paymentSystem={subscription.payment_plan.payment_system}
        />
      );
    }
  }

  return (
    <div className={s.successPageWrapper}>
      <div className={s.backgroudGradient } />
      <H1
        className={cn('text-center mb-10 cy-success-page-title', s.title)}
      >
        {t('All done — you now can enjoy all smart features')}
      </H1>
      <div
        className={cn(s.imageWrapper, {
          [s.imageWrapperGiftLink]: !!giftCoupon,
        })}
      >
        <Image
          width={331}
          height={399}
          src="/pagesImages/blackfriday/success-payment.svg"
          layout="responsive"
          objectFit="cover"
          unoptimized={true}
        />
      </div>

      {footerContent}
    </div>
  );
}
